import { Model } from './model';
import { Profile } from './profile';

// class Profile extends Model {
//   name: string;
//   surname: string;
//   companyName: string;
//   email: string;
//   phone: string;
//   mobilePhone: string;
// }

export enum AccountType {
  Company = 'Company',
  Private = 'Private'
}

class Subaccount extends Model {
  superaccountName: string;
}

class Account extends Model {
  type: AccountType;
  postpaid: boolean;
  autoRefillEnabled: boolean;
  subaccount: Subaccount;
  isCustomer: boolean;
  mobilePhone?: string;
  canRegisterAgcomAlphaSender?: boolean;
  canSendOnlyToRegistrationNumber?: boolean;
  canRegisterSender?: boolean;
  companyName: string;
  defaultMessageTemplate: number;
  titanLoginRedirectUrl?: string;
  isUpgraded?: boolean;
}

export class Preferences extends Model {
  language: string;
  dateFormat: string;
  hourFormat: string;
  displayCredits?: string[];
  messageObfuscationType?: string;
  hidePrivacyPopUpDate?: string;
}

class Billing extends Model {
  address: string;
  city: string;
  companyName: string;
  currency: string;
  currencySimbol: string;
  invoicingEmail?: string;
  paCode?: string;
  province?: string;
  taxCode?: string;
  vatCode?: string;
  zipCode?: string;
}

class Configuration extends Model {
  defaultTitle: string;
}

export class User extends Model {
  login: string;
  nation: string;
  defaultNation: string;
  currency: string;
  canBuy: boolean;
  profile: Profile;
  account: Account;
  billing?: Billing;
  preferences: Preferences;
  configuration?: Configuration;

  afterDeserialize(input: any) {
    if (this.profile) {
      this.profile = Profile.deserialize(this.profile);
    }
    if (this.account) {
      this.account = Account.deserialize(this.account);
    }
    if (this.preferences) {
      this.preferences = Preferences.deserialize(this.preferences);
    }
  }

  /**
   * Agcom validate, only for italy
   */
  hasValidatedSendersList(): boolean {
    return this.account && this.account.canRegisterAgcomAlphaSender;
  }
}

export enum MessageObfuscationType {
  NO_OBFUSCATION = 'NO_OBFUSCATION',
  OBFUSCATE_MESSAGE_BODY = 'OBFUSCATE_MESSAGE_BODY'
}
